import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery.noConflict();
export class ZIDXPropertyInquiry implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxPropertyInquiryContainer";
    }
    render(){
        // console.log("inquiry");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxPropertyInquiryContainer", "firstName", "local_lead_first_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxPropertyInquiryContainer", "lastName", "local_lead_last_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxPropertyInquiryContainer", "phone", "local_lead_phone");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxPropertyInquiryContainer", "email", "local_lead_email");
    }
}